import { createContext } from "react"

export const MetaMaskContext = createContext(undefined)
